import { memo } from 'react';
import { Button, DialogActions } from '@mui/material';

import { useTranslation } from 'react-i18next';
import PerfectButton from '../../../../../components/common/buttons/PerfectButton';
import STRING_KEYS from '../../../../../language/keys';
import { style } from './style';

type ModalActionsProps = {
  onCreateEducation : () => void,
  onCloseModal: () => void,
  isDisabled: boolean,
}

const ModalActions = ({
  onCreateEducation,
  onCloseModal,
  isDisabled,
}: ModalActionsProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <DialogActions
      sx={ style.dialogAction }
    >
      <Button onClick={ onCloseModal }>
        { translate(STRING_KEYS.CANCEL) }
      </Button>
      <PerfectButton
        type="submit"
        disabled={ isDisabled }
        title={ translate(STRING_KEYS.CREATE_NEW_EDUCATION_INSTITUTE) }
        onClick={ onCreateEducation }
        icon={ <></> }
      />
    </DialogActions>
  );
};

export default memo(ModalActions);
